"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tenant = void 0;
const enums_1 = require("./enums");
const brands_1 = require("./brands");
const exceptions_1 = require("./exceptions");
const testTenants = [enums_1.TenantEnum.JS_TEST, enums_1.TenantEnum.MD_TEST];
class Tenant {
    static getAllTenants() {
        return Object.values(enums_1.TenantEnum).map(tenantValue => Tenant[tenantValue]);
    }
    static getTenantsByBrand(brand) {
        return this.getAllTenants().filter(tenant => tenant.getBrand() === brand);
    }
    static getTenantsByShortBrand(brand) {
        return this.getAllTenants().filter(tenant => tenant.getShortBrand() === brand);
    }
    static fromOrderId(orderId) {
        /*
         * This roughly translates to: "1-" followed by 2 capital letters, followed by anything.
         *
         * The 2 capital letters (i.e. the tenant prefix) are captured in a group.
         */
        const matches = /^1-([A-Z]{2})/.exec(orderId);
        if (matches && matches.length > 1) {
            const prefix = matches[1];
            if (prefix in Tenant.prefixMap) {
                return Tenant.prefixMap[prefix];
            }
        }
        throw new exceptions_1.InvalidOrderIdException(orderId);
    }
    constructor(value) {
        const tenant = Tenant[value];
        if (tenant)
            return tenant;
        this.value = value;
    }
    is(tenant) {
        if (tenant instanceof Tenant) {
            return this.value === tenant.value;
        }
        return tenant === this.value;
    }
    getUrlPrefix() {
        switch (this.value) {
            case enums_1.TenantEnum.JS_DE:
                return 'js-de';
            case enums_1.TenantEnum.JS_AT:
                return 'js-at';
            case enums_1.TenantEnum.MD_DE:
                return 'md-de';
            case enums_1.TenantEnum.MD_AT:
                return 'md-at';
            case enums_1.TenantEnum.MD_CH:
                return 'md-ch';
            default:
                throw new exceptions_1.UrlPrefixNotDefinedException(this.value);
        }
    }
    getCountryCode() {
        switch (this.value) {
            case enums_1.TenantEnum.JS_DE:
            case enums_1.TenantEnum.MD_DE:
            case enums_1.TenantEnum.JS_NOW_DE:
            case enums_1.TenantEnum.JS_TEST:
            case enums_1.TenantEnum.MD_TEST:
                return enums_1.CountryCode.Germany;
            case enums_1.TenantEnum.JS_AT:
            case enums_1.TenantEnum.MD_AT:
                return enums_1.CountryCode.Austria;
            case enums_1.TenantEnum.MD_CH:
                return enums_1.CountryCode.Switzerland;
            default:
                throw new exceptions_1.CountryCodeNotDefinedException(this.value);
        }
    }
    getBrand() {
        return brands_1.tenantBrandMap[this.value];
    }
    getShortBrand() {
        return brands_1.tenantShortBrandMap[this.value];
    }
    belongsTo(brandOrCountryCode) {
        return (this.getBrand() === brandOrCountryCode ||
            this.getShortBrand() === brandOrCountryCode ||
            this.getCountryCode() === brandOrCountryCode);
    }
    belongsToShortBrand(brand) {
        return this.getShortBrand() === brand;
    }
    isTestTenant() {
        return testTenants.includes(this.value);
    }
    toString() {
        return this.value;
    }
    toJSON() {
        return this.value;
    }
    getPrefix() {
        const prefix = Object.keys(Tenant.prefixMap).find(key => Tenant.prefixMap[key].is(this.value));
        if (prefix) {
            return prefix;
        }
        throw new exceptions_1.InvalidPrefixMapException(this.value);
    }
}
exports.Tenant = Tenant;
Tenant.JS_DE = new Tenant(enums_1.TenantEnum.JS_DE);
Tenant.JS_NOW_DE = new Tenant(enums_1.TenantEnum.JS_NOW_DE);
Tenant.JS_AT = new Tenant(enums_1.TenantEnum.JS_AT);
Tenant.MD_DE = new Tenant(enums_1.TenantEnum.MD_DE);
Tenant.MD_AT = new Tenant(enums_1.TenantEnum.MD_AT);
Tenant.MD_CH = new Tenant(enums_1.TenantEnum.MD_CH);
Tenant.JS_TEST = new Tenant(enums_1.TenantEnum.JS_TEST);
Tenant.MD_TEST = new Tenant(enums_1.TenantEnum.MD_TEST);
/**
 * Map from tenant prefixes (as part of order IDs) to the actual tenant.
 *
 * This needs to be kept closely in sync with the tenant prefixes in order-backend (OrderIdSequenceGenerator).
 *
 * DO NOT make changes here without also adjusting order-backend!
 */
Tenant.prefixMap = {
    JD: Tenant.JS_DE,
    JA: Tenant.JS_AT,
    ND: Tenant.JS_NOW_DE,
    TT: Tenant.JS_TEST,
    MD: Tenant.MD_DE,
    MA: Tenant.MD_AT,
    MC: Tenant.MD_CH,
    TM: Tenant.MD_TEST,
};
//# sourceMappingURL=tenant.js.map